import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

// Config
import { getPlaceholder } from "../../config/values";

// Component
import colors from "../../config/colors";
import { useAppInsights } from "../../utils/telemetry/AppInsights";

const useStyles = makeStyles(theme => ({
  image: {
    display: "block",
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  placeholder: {
    width: "100%",
    borderRadius: theme.shape.borderRadius,
    minHeight: 163,
    backgroundColor: colors.concrete,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: ({ icon }) => `url(${icon})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center"
  },
  imageContainer: {
    minWidth: ({ minWidth }) => minWidth,
    width: "100%",
    paddingBottom: "56.25%",
    display: "block",
    position: "relative",
    overflow: "hidden",
    borderRadius: theme.shape.borderRadius,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundImage: ({ image }) => `url(${image})`
  },
  loading: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: " translate(-50%, -50%)"
  }
}));

const MediaItemPlaceholder = ({ filename, src, minWidth }) => {
  const [image, setImage] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const classes = useStyles({
    image,
    icon: getPlaceholder(filename),
    minWidth
  });
  const { trackException } = useAppInsights();

  React.useEffect(() => {
    let mounted = true;
    if (src) {
      fetch(src)
        .then(res => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.blob();
        })
        .then(img => {
          if (mounted) {
            setImage(window.URL.createObjectURL(img));
            setLoading(false);
          }
        })
        .catch(() => {
          trackException(`Failed to get source: ${src}`);
          if (mounted) setLoading(false);
        });
    } else setLoading(false);
    return () => {
      mounted = false;
    };
  }, [src, trackException]);

  return (
    <div className={image ? classes.imageContainer : classes.placeholder}>
      {loading && (
        <span className={classes.loading}>
          <CircularProgress size={50} thickness={3} />
        </span>
      )}
    </div>
  );
};

MediaItemPlaceholder.propTypes = {
  filename: PropTypes.string.isRequired,
  src: PropTypes.string,
  minWidth: PropTypes.string
};

MediaItemPlaceholder.defaultProps = {
  src: null,
  minWidth: ""
};

export default MediaItemPlaceholder;
